import React from 'react'
import styled from '@emotion/styled'
import { SectionTitle } from './styles'
import { array, string } from 'prop-types'
import { ServiceInformationCard } from '@jelly/components'
import { generateAffiliateLink, getParagraphSections, splitParagraphString } from '@jelly/utils'

// Styled Components via Emotion
const SectionWrapper = styled.div``
const CardWrapper = styled.div`
	margin: 20px 0;
`

const shouldSplitFirstParagraph = ({ review, isFeaturedBestPick }) =>
	review && review.fullReviewTest && !isFeaturedBestPick

ProductsServices.propTypes = {
	services: array.isRequired,
	title: string.isRequired,
}
/**
 * Section for Products and Services based on Service location set in CCM
 *
 * @param {Array} props.services :: list of services provided
 * @param {String} props.title :: title of the section
 */
export function ProductsServices({ services, title, categoryWidgetId }) {
	return (
		<SectionWrapper>
			<SectionTitle as="h3">{title}</SectionTitle>
			{services.map((service, i) => {
				const { description, isBestPickService, isFeaturedBestPick, pricing, review } = service
				if (isFeaturedBestPick || !isBestPickService) {
					const affiliateLink = generateAffiliateLink(pricing)
					let displayText = { serviceDescription: description }

					if (shouldSplitFirstParagraph({ review, isFeaturedBestPick })) {
						const paragraphs = splitParagraphString(review.fullReviewTest)
						const firstParagraph = getParagraphSections(paragraphs, 0, 1)
						const restOfParagraphs = getParagraphSections(paragraphs, 2, paragraphs.length)
						displayText = { serviceDescription: firstParagraph, restOfReview: restOfParagraphs }
					}

					return (
						<CardWrapper key={`${service.serviceName}-${i}`}>
							<ServiceInformationCard
								affiliateLink={affiliateLink}
								descriptionText={displayText}
								categoryWidgetId={categoryWidgetId}
								{...service}
							/>
						</CardWrapper>
					)
				}
				return null
			})}
		</SectionWrapper>
	)
}
